import axios from 'axios';
import fileAxios from './fileAxios';
import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
import { jumpShutDownPage } from '@/libs/util';
import channelAxios from '@/API/channelAxios';
import { getSign } from './requestEncryption';
import Cookies from 'js-cookies';

// let querystring = require('querystring');
// 允许跨域请求发送cookie
axios.defaults.withCredentials = true;
axios.defaults.baseURL = `${window._env_.VUE_APP_REQUEST_ADDRESS}/${window._env_.VUE_ENVIRONMENT_ALL}/`;
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/order-lifecycle-uat02' : '/order-lifecycle-uat02';
axios.defaults.headers.post['Content-Type'] = 'application/json'; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
axios.interceptors.request.use(
  config => {
    // if (config.headers.common.Accept.indexOf('application/json') >= 0) {
    //   // config.data = querystring.stringify(config.data);
    //   console.log(config);
    //
    // }
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: 'c0c73417cf58cb87e146a78f6e44ef44',
      accessKeySecret: '7B3A866D-7343-540C-30FD-0E71BE1B667B'
    });
    config.headers['sysId'] = 'c0c73417cf58cb87e146a78f6e44ef44';
    config.headers['timeOut'] = new Date().getTime();
    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  res => {
    // 停机维护
    if (res.data && res.data.status === '503') {
      jumpShutDownPage(res.data.data);
    }

    const contentType = (res.headers && res.headers['content-type']) || '';
    if (contentType.indexOf('application/octet-stream') >= 0) {
      return res;
    }

    let json = res.data;
    // 文件流响应（Blob）直接返回，不做业务状态码校验
    if (json instanceof Blob) {
      return res;
    }
    if (json && json.status !== '200' && json && json.status !== '302') {
      // Notification.error({
      //   message: json.error || json.err
      // });
    } else if (json && json.status === '302') {

    }
    return res;
  },
  error => {
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    Notification.error({
      message: (error.response && error.response.err) || '请求服务器失败'
    });
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default axios;

/**
 * 电汇查询（财务） 国际
 */

// 查询电汇单列表
export const listTelegraphicTransferInternation = (params) => axios.post('/telegraphicTransferInternation/listTelegraphicTransferInternation', params);
export const listTelegraphicTransferInternationBusiness = (params) => axios.post('/telegraphicTransferInternation/listTelegraphicTransferInternationBusiness', params);
// 查询电汇单明细
export const telegraphicTransferInternation = (id) => axios.get(`/telegraphicTransferInternation/${id}`);
// 确认收款
export const confirmCollection = (params) => axios.post('/telegraphicTransferInternation/confirmCollection', params);

/**
 * 商务审核 国际
 */
// 分页查询国际合同列表 ---商务
export const getIntOrdersContractList = (params) => axios.post('/contract/getIntOrdersContractList', params);

// 分页查询国际合同列表 ---商务（海外）
export const getBGOrdersContractList = (params) => axios.post('/contract/getBGOrdersContractList', params);

// 分页查询国际合同列表(待/已分配) ---商务
export const selectContractInfoListForBusiness = (params) => axios.post('/contract/selectContractInfoListForBusiness', params);
// 商务审批合同接口 同意、驳回
export const saveBusinessContractInfo = (params) => axios.post('/contract/saveBusinessContractInfo', params);
// 获取(查询)国际物流信息列表
export const getIntelLogisticsList = (params) => axios.post('/intelLogistics/getIntelLogisticsList', params);
// 插入国际物流信息
export const saveIntelLogistics = (params) => axios.post('/intelLogistics/saveIntelLogistics', params);
// 根据ID更新国际物流信息(包括逻辑删除)
export const updateIntelLogistics = (params) => axios.post('/intelLogistics/updateIntelLogistics', params);
// 根据ID更新国际物流信息(包括逻辑删除)
export const getIntelLogisticsDetail = (params) => axios.get('/intelLogistics/getIntelLogisticsDetail', { params });
export const getBusinessList = (params) => axios.post('/overseasExOrder/businessList', params);
// 查询汇款配置项
export const getRemittanceConfig = (id) => axios.get(`/telegraphicTransferInternation/getRemittanceConfig?configType=${id}`);

// 查询汇款配置项
export const importIntelLogistic = (params) => axios.post(`/intelLogistics/importIntelLogistic`, params, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getCalculateInterSettlementAmountV2 = (params) => axios.post(`/intelCalculationRules/getCalculateInterSettlementAmountV2`, params); // 查询实际结算金额 无加密

export const getCurrencyList = (params) => axios.get('/common/getCurrencyList'); // 获取币种
export const getIntelLogisticsDetailByFhNum = (fhNum) => axios.get('/intelLogistics/getIntelLogisticsDetailByFhNum', { params: { fhNum } }); // 根据物流编码获取国际物流轨迹
export const getIntelLogisticsDetailByFhNumNew = (fhNum) => axios.get('/common/getIntelLogisticsDetailByFhNum', { params: { fhNum } }); // 根据物流编码获取国际物流轨迹

// 获取仓库数据
export const getDictData = (params) => axios.get('/dict/getDictData', { params });
// 汇款录入 商务
// 召回
export const recallTelegraphicTransferForm = (id) => axios.get(`/telegraphicTransferInternation/recallTelegraphicTransferForm/${id}`); //
// 校验收款单号和获取实际到款金额
export const verifyreceiptnumber = (params) => axios.get(`/telegraphicTransferInternation/verifyReceiptNumber`, { params });
// * 校验合同编号和获取合同数据
export const verifyContractNum = (params) => axios.get(`/telegraphicTransferInternation/verifyContractNum`, { params });
// * 获取币种
export const getCurrency = (params) => axios.post(`/telegraphicTransferInternation/getBusinessCurrency?importAccount=${params}`);
// 废弃
// abandonTelegraphicTransferForm/{id}
export const abandonTelegraphicTransferForm = (id) => axios.get(`/telegraphicTransferInternation/abandonTelegraphicTransferForm/${id}`); //
// 保存电汇单
export const addTelegraphicTransferInternationBusiness = (params) => axios.post(`/telegraphicTransferInternation/addTelegraphicTransferInternationBusiness`, params); // 查询实际结算金额 无加密
// 汇率值波动是否大于5%校验
export const getCheckExchangeRateFluctuation = (params) => axios.post(`/telegraphicTransferInternation/checkExchangeRateFluctuation`, params);
// 通过合同编号获取客户名称及合同币种
export const getOrderUnitAndCurrencyByContractNum = (params) => axios.get('/contract/getOrderUnitAndCurrencyByContractNum', { params });
// 根据业务实体获取汇入公司，汇入账号及交易币种
export const getCompanyAndBankByBusinessEntity = (params) => axios.get('/telegraphicTransferInternation/listCompanyBankCurrencyByBusinessEntity', { params });
// 获取汇率
export const getExchangeRate = (params) => axios.post('/fincDailyRates/query', params);
// 获取目标币种数据
export const getTargetCurrency = (params) => axios.get('/telegraphicTransferInternation/listVirtualBankAccountByBusinessEntity', { params });
// 交易币种

export const currencys = (params) => axios.get('/telegraphicTransferInternation/currencys', { params });
// 汇入公司:
export const getCountryList = (params) => axios.get('/telegraphicTransferInternation/listCompany', { params });
// 汇入账号
export const listBank = (params) => axios.get('/telegraphicTransferInternation/listBank', { params });
// // 付款用途：付款方式: 付款类型:
// export const getRemittanceConfig = (params) => axios.get('/telegraphicTransferInternation/getRemittanceConfig', { params });
// // /order-lifecycle/?configType=1
// 汇款编号：
export const getCreateTelNumber = (params) => axios.get('/telegraphicTransferInternation/getCreateTelNumber', { params });
// 编辑回显
export const listWaterOrderAttachment = (id) => axios.get(`/telegraphicTransferInternation/${id}`);
// 导出
export const financeExportTelegraphicTransfer = (params) => axios.post(`/telegraphicTransferInternation/businessExportTelegraphicTransfer`, params, { responseType: 'blob' }); // 查询实际结算金额 无加密
// 查询水单列表（get）
export const getlistWaterOrderAttachment = (transferId) => axios.get('/telegraphicTransferInternation/listWaterOrderAttachment', { params: { transferId } });

// 召回已申请发货单 暂无法使用
export const recallInvoiceHasBeenApplied = (params) => axios.post('/intelBusinessDelivers/recallApply', params);

// 废弃已申请发货单 暂无法使用
export const abandonInvoiceHasBeenApplied = (params) => axios.post(`/intelBusinessDelivers/abandonApply`, params);

// 查询已申请发货接口
export const getRequestedAnInvoice = (params) => axios.post('/intelBusinessDelivers/requestedAnInvoice', params);

// 已申请发货导出pi
export const exportPi = (params) => axios.post('/intelBusinessDelivers/exportPi', params, { responseType: 'blob' });

// 获取申请发货单详情
export const getObtainTheShippingDetailsOfTheApplication = (params) => axios.post('/intelBusinessDelivers/intelPartialInvoiceDetail', params);

// 修改申请发货单
export const recomposeObtainTheShippingDetailsOfTheApplication = (params) => axios.post('/intelBusinessDelivers/submitPartialShipments', params);

// 待分配申请发货单列表
export const getTreatAssignmentList = (params) => axios.post('/intelBusinessDelivers/treatAssignmentList', params);

// 待审请发货 提交申请
export const submitanapcplication = (params) => axios.post('/intelBusinessDelivers/submitPartialShipments', params);

// 待审请发货 提交申请 （海外）
export const bgSubmitPartialShipments = (params) => axios.post('/intelBusinessDelivers/bgSubmitPartialShipments', params);

//  校验接口
export const checkinterface = (params) => axios.post('/intelBusinessDelivers/batchVerification', params);
// 待审请发货 列表数据 国际
export const getintelPendingRequisitionList = (params) => axios.post('/intelBusinessDelivers/intelPendingRequisitionList', params);

// 待审请发货 列表数据 国际
export const bgIntelPendingRequisitionList = (params) => axios.post('/intelBusinessDelivers/bgIntelPendingRequisitionList', params);
//  关务  待审核发货列表
export const ordertoBeReviewed = (params) => axios.post('/intelCustomsApproval/invoicesPendingApproval', params);
// 订单员 待审核发货单
export const getInvoiceToBeReviewed = (params) => axios.post('/intelOrderClerkApprove/treatApproveList', params);
// 订单员 已审核发货单
export const getInvoiceHasBeenReviewed = (params) => axios.post('/intelOrderClerkApprove/alreadyApproveList', params);
// 订单员撤回订单
export const orderTakerRevocation = (params) => axios.post('/intelOrderClerkApprove/orderRecall', params);
// 关务 已审批列表数据
export const ApprovedListOrder = (params) => axios.post('/intelCustomsApproval/shipmentApprovedSingle', params);
// 关务 审批接口
export const examineAndApprove = (params) => axios.post('/intelCustomsApproval/customerApprovalAndRejection', params);

// 订单员审批接口
export const orderClerkApproval = (params) => axios.post('/intelOrderClerkApprove/intelOrderClerkApproval', params);

// 订单员申请发货单详情 分配金额
export const orderClerkAllocated = (id) => axios.get('/intelOrderClerkApprove/getAllocationInformation', { params: { id } });
// 提交分批发货/编辑提交分批发货 检验授权邮箱是否为必填
export const mailboxVerification = (params) => axios.post('/common/checkElectronicCertItemByMaterialNumber', params);

// 获取该合同的材积信息
export const getContractProductVolume = (params) => axios.get(`/contractProduct/getContractIdAndVolume`, { params });

// 根据合同导出表格
// export const exportContractExcel = (params) => axios.get(`/contractProduct//getContractIdAndExcel?contractNum=${params.strContractCode}&projectName=${params.projectName}&orderUnit=${encodeURI(params.orderUnit)}&soldCountry=${params.soldCountry}`, { responseType: 'blob' });
export const exportContractExcel = (params) => axios.post(`/contractProduct/getContractIdAndExcel`, { ...params }, { responseType: 'blob' });

/**
 * @description 创建保存附件信息
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const saveAttachmentInformation = (params) => axios.post('/intelPartialInvoiceFile/CreateFile', params);

/**
 * @description 删除附件信息
 * @param params
 * @param params.id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const deleteAttachmentInformation = (params) => axios.post('/intelPartialInvoiceFile/DeleteFile', params);

/**
 * @description 查询附件信息
 * @param params
 * @param params.typeId 发货单号
 * @returns {Promise<AxiosResponse<any>>}
 */
export const searchAttachmentInformation = (params) => axios.post('/intelPartialInvoiceFile/FileByPartialId', params);

/**
 * 获取阿里文件的下载文信息
 */
export const getAliOSSDownloadInfo = (id) =>
  channelAxios.get(`/partners-common-service/file/detail/getAllFile/${id}`);

/**
 * 分销驳回接口
 */
export const cancelOrder = (params) =>
  channelAxios.post(`/partners-order-service/order/cancelOrder`, params);

/**
 * 新分销驳回接口
 */
export const cancelOrderForCes = (params) =>
  channelAxios.post(`/partners-order-service/order/cancelOrderForCes`, params);

/**
 * 通过英文名称查找国家
 * @param countryName 国家英文名称
 */
export const acquiringCountry = (countryName) =>
  axios.post(`/country/acquiringCountry`, { countryName });

/**
 * 获取客期
 * @param {
 *  Array.<{soldToCountriesName: string,
 *  tradeTerminology: string,
 *  productCode: string,
 *  productName: string,
 *  companyCode: string,
 *  companyName: string
 * }>} productList
 */
export const getSuggestedProductList = (productList) =>
  axios.post(`/contractProduct/getSuggestedProductList`, productList);

/**
 * 撤销分配记录查询
 * @param {Object} params 国家英文名称
 * @param {string} params.contractNum 合同编号
 * @param {string} params.projectName 项目名称
 * @param {string} params.orderUnit 代理商名称
 * @param {string} params.departmentName 部门
 * @param {string} params.regionName 区域
 * @param {string} params.applicationName 申请人
 * @param {string} params.createBeginTime 开始时间
 * @param {string} params.createEndTime 结束时间
 * @param {number} params.pageIndex 分页页码
 * @param {number} params.pageSize 分页大小
 */
export const revokeAssignRecordPage = (params) =>
  axios.post(`/contractAssign/revokeAssignRecordPage`, params);

/**
 * 代理商合同办理回退
 * @param reContractId 国家英文名称
 */
export const submitToBack = (reContractId) =>
  axios.get(`/returns/ag/submitToBack`, { params: { reContractId } });

/**
 * 获取退换货列表的订单类别下拉
 * @param {string[]} params 下拉类型
 */
export const getOrderDictData = (params) =>
  axios.post(`/orderCommon/getDictData`, params);
/**
 * 关务,认证可以查看,电池认证管理,导入
 * @param {string[]} params
 */
export const getImportBatterData = (params) => axios.post('/battery/batchImport', params, { headers: { 'Content-Type': 'multipart/form-data' } });
/**
 * 关务,认证可以查看,电池认证管理,列表
 * @param {string[]} params
 * @param {string[]} params.pageSize // 分页页码
 * @param {string[]} params.pageIndex // 分页大小
 * @param {string[]} params.productName // 产品型号
 */
export const getBatteryDataList = (params) =>
  axios.get(`/battery/list`, { params });
/**
 * @description 删除当前列表行数据
 * @param params
 * @param params.id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const deleteBatteryImportRowDataList = (params) => axios.post(`/battery/delete?id=${params}`);
//
/**
 * @description 修改更新当前行数据
 * @param params
 * @param params.id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const updateBatteryImportRowDataList = (params) => axios.post(`/battery/update`, params);

/**
 * 客期变更提交申请
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102316
 */
export const submitChangeApply = (params) => axios.post(`/cedd-change/submit`, params);

/**
 * 客期变更提交申请上传附件
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102252
 */
export const submitChangeUpload = (params) => axios.post(`/cedd-change/upload`, params);

/**
 * 提交变更申请页面-根据合同号获取基础信息加详情列表接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102268
 */
export const getCeddChangeApplyDetail = (contractNum) => axios.get(`/cedd-change/apply/detail-list`, { params: { contractNum } });

/**
 * 客期变更详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102268
 */
export const getCeddChangeDetail = (applicationId) => axios.get(`/cedd-change/detail`, { params: { applicationId } });

/**
 * 变更审批日志接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102244
 */
export const getCeddChangeApprovalLog = (applicationId) => axios.get(`/cedd-change/flow/log`, { params: { applicationId } });

/**
 * 变更申请列表接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102180
 */
export const getCeddChangeApplyList = (params) => axios.post(`/cedd-change/list`, params);

/**
 * 变更列表批量导出申请单详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/103372
 */
export const getCeddChangeTodoList = (params) => axios.post(`/cedd-change/todo`, params);

/**
 * 变更列表批量导出申请单详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/103364
 */
export const getCeddChangeApprovedList = (params) => axios.post(`/cedd-change/completed`, params);

/**
 * 我的审批单-待办/已办tab-申请人下拉列表数据接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102220
 */
export const getCeddChangeApplicantAll = (userName) => axios.get(`/cedd-change/list/applicant-all`, { params: { userName } });

/**
 * 我的审批单-已审批tab-供应统筹审批人下拉列表数据接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102228
 */
export const getCeddChangeApproverAll = (userName) => axios.get(`/cedd-change/list/approver-all`, { params: { userName } });

/**
 * 变更列表批量导出申请单详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102188
 */
export const batchExportCeddChange = (params) =>
  fileAxios.post(`/cedd-change/list/batch-export`, params, { responseType: 'blob' });

/**
 * 提前审批导出详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102148
 */
export const exportCeddChangeAhead = (applicationId) =>
  fileAxios.get(`/cedd-change/ahead/detail-export`, { params: { applicationId }, responseType: 'blob' });

/**
 * 延迟审批导出详情接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102156
 */
export const exportCeddChangeDelay = (applicationId) =>
  fileAxios.get(`/cedd-change/delay/detail-export`, { params: { applicationId }, responseType: 'blob' });

/**
 * 提前审批批量导入建议交期与共识客期接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102164
 */
export const importCeddChangeAhead = (applicationId, formData) =>
  axios.post(`/cedd-change/ahead/import`, formData, { params: { applicationId } });

/**
 * 延迟审批批量导入共识客期接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102172
 */
export const importCeddChangeDelay = (applicationId, formData) =>
  axios.post(`/cedd-change/delay/import`, formData, { params: { applicationId } });

/**
 * 客期变更审批接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/102140
 */
export const ceddChangeApprove = (params) => axios.post(`/cedd-change/approval`, params);

/**
 * 客期变更审批接口
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/105268
 */
export const getFestivalHoliday = () => axios.get(`/cedd-change/getFestivalHoliday`);

/**
 * 获取下一审批人list
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/105453
 */
export const getNextApprover = (flowId) => axios.get(`/cedd-change/getPendingApprovers`, {
  params: { flowId }
});

/**
 * 审批变更列表批量导出申请单详情
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/105673
 */
export const getOrderBatchExport = (params) => fileAxios.post(`/cedd-change/list/orderBatch-export`, params, {
  responseType: 'blob'
});

/**
 * 审批过的列表全量导出
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/109383
 */
export const getExportAll = (params) => fileAxios.post(`/cedd-change/completed/export/all`, params, {
  responseType: 'blob'
});

/**
 * 实时修改变更单明细订单行建议交期和共识变更客期字段数据
 * @see https://yapi.ruijie.com.cn/project/425/interface/api/109398
 */
export const saveProductDtl = (params) => axios.post(`/cedd-change/saveProductDtl`, params);

/**
 * 召回客期变更申请
 */
export const recallProductDtl = (params) => axios.post(`/cedd-change/recallApplication`, params);

// 获取根据合同ID获取所选收货地址
export const getReceiptInterAddressByContractId = (contractId) => axios.get(`/overseasExOrder/getReceiptAddressByContractId`, { params: { contractId } });
/**
 * 获取退换货列表的税率下拉选数据
 * @param {string[]} params 下拉类型
 */
export const getTaxRateBySupplyUnitCode = (supplyUnitCode) => axios.get(`/overseasExOrder/getTaxRateBySupplyUnitCode`, { params: { supplyUnitCode } });
/**
 * 获取退换货订单明细列表
 * @param {string[]} params 下拉类型
 */
export const getQueryOverseasOrderInfoData = (params) => axios.get(`/overseasExOrder/queryOverseasOrderInfoFromDsData?contractNum=${params.contractNum}&oldContractNum=${params.oldContractNum}`);

/**
 * 国际退换货销售发起申请列表
 * @param {string{}} params 搜索表单
 */
export const getSalesIntOrdersContractDataList = (params) => axios.post('/contract/getSalesIntOrdersContractList', params);
/**
 * 商务: 待申请发货,导入发货清单模板
 * @param {string[]} params 下拉类型
 */

export const getImportShippingDataList = (params) => axios.post('/intelBusinessDelivers/importPartialShipment', params, { headers: { 'Content-Type': 'multipart/form-data' } });

// 分配金额
export const getIntelPartialId = (params) => axios.get('/intelBusinessDelivers/getIntelPartialId', { params });

/**
 * 保存货代信息
 */
export const freightForwardersave = (params) => axios.post('/freightForwarder/save', params);

/**
 * 更新货代信息
 */
export const freightForwarderupdate = (params) => axios.post('/freightForwarder/update', params);

/**
 * 根据id获取货代信息
 */
export const freightForwardergetById = (params) => axios.get('/freightForwarder/getById', { params });

/**
 * 获取货代信息列表
 */
export const freightForwardergetList = (params) => axios.post('/freightForwarder/getList', params);

/**
 * 根据货代编号获取货代信息
 */
export const getByForwarderCode = (params) => axios.get('/freightForwarder/getByForwarderCode', { params });

/**
 * 批量删除货代信息
 */
export const freightForwarderbatchDelete = (params) => axios.post('/freightForwarder/batchDelete', params);

/**
* 批量删除货代信息
*/
export const freightForwarderdelete = (params) => axios.get('/freightForwarder/delete', { params });
/**
 * 商务,关务,订单员:  商务已办, 关务,订单员待办,导出发货单明细
 * @param {string[]} params 下拉类型
 */
export const getExportPartialInvoice = (params) => fileAxios.post(`/intelBusinessDelivers/exportPartialInvoice`, params, {
  responseType: 'blob'
});
/**
 * 退货合同/退还返利
 */
export const getRefundRebateAmount = (contractId) => axios.get('/overseasExOrder/releaseRebate', { params: { contractId } });

// 根据合同号查询仓库地址
export const contractgetContractNumberByWarehouse = (params) => axios.get(`/contract/getContractNumberByWarehouse`, { params: { ...params } });

// 根据合同号查询是否仓库
export const isBGContract = (params) => axios.get(`/contract/isBGContract`, { params: { ...params } });
